import {
  SET_PLAYING,
  SET_CORRECT_SOUNDS_PLAYED,
  SET_INCORRECT_SOUNDS_PLAYED,
} from 'actions/types';
import { audioURL } from 'config';
import _ from "lodash";


const filter = 'audio';

const NUMBER_OF_CORRECT_SOUNDS = 7;
const NUMBER_OF_INCORRECT_SOUNDS = 6;
const correctSoundStrings = [1392,1393,1394,1395,1396,1397,1398];
const incorrectSoundStrings = [635,1400,1401,1402,1403,1404];

export const setPlaying = (audioSrc, isPlaying) => ({
  filter,
  type: SET_PLAYING,
  payload: { audioSrc, isPlaying },
});

export const playAudio = (src, options) => {
  window.audioPlayer.playSrc(src, options);
};

export const toggleSequence = (src, options) => {
  window.audioPlayer.toggleSequence(src, options);
};

export const toggleAudio = (src, options) => {
  window.audioPlayer.togglePlaySrc(src, options);
};

export const stopAudio = (src) => {
  window.audioPlayer.stop(src);
};

const setCorrectSoundsPlayedCount = (count) => ({
  filter,
  type: SET_CORRECT_SOUNDS_PLAYED,
  payload: count,
});

const setIncorrectSoundsPlayedCount = (count) => ({
  filter,
  type: SET_INCORRECT_SOUNDS_PLAYED,
  payload: count,
});

const getStringAudioPath = (editingActivity, solutionLocale, strings, locales, stringNumber) => {
  let audioPath = '';
  const activityLocale = editingActivity 
    ? (editingActivity.activity.currentLanguageVersion.locale 
        ? editingActivity.activity.currentLanguageVersion.locale : 'en') : 'en';
  const locale = solutionLocale ? solutionLocale : _.find(locales, { code: activityLocale });
  const search = _.find(strings, { stringNumber });
  const string = _.get(search?.data, locale.code);
  
  if (string?.stringAudio) {
    audioPath = `${audioURL}/Generic/Strings/${locale.name}/${string.stringAudio}`;
  }
  console.log('getStringAudioPath',[string, locale, audioPath]);

  return audioPath;
}

export const playApplause = (forAnimation = false) => async (
  dispatch,
  getState
) => {
  const {
    flinkPlay: { solutionLocale },
  } = getState();

  const localeName = solutionLocale ? solutionLocale.name : 'English';

  const audioFilename = forAnimation ? 'applause1.mp3' : 'applause2.mp3';

  const src = `${audioURL}/Generic/ActivityResults/${localeName}/${audioFilename}`;
  playAudio(src);
};

export const playCorrectSound = () => (dispatch, getState) => {
  const {
    audio,
    flinkPlay: { solutionLocale },
    common: { strings, locales },
    flinkMake: { activity: { editingActivity } }
  } = getState();

  const correctSoundsPlayed =
    NUMBER_OF_CORRECT_SOUNDS === audio.correctSoundsPlayed
      ? 1
      : audio.correctSoundsPlayed + 1;

  const audioPath = getStringAudioPath(
    editingActivity, 
    solutionLocale, 
    strings, 
    locales, 
    correctSoundStrings[correctSoundsPlayed - 1]
    );

  const src = audioPath ? audioPath : `${audioURL}/Generic/Feedback/${
    solutionLocale ? solutionLocale.name : 'English'
  }/correct${correctSoundsPlayed}.mp3`;

  playAudio(src);

  dispatch(setCorrectSoundsPlayedCount(correctSoundsPlayed));
};

export const playIncorrectSound = () => (dispatch, getState) => {
  const {
    audio,
    flinkPlay: { solutionLocale },
    common: { strings, locales },
    flinkMake: { activity: { editingActivity } }
  } = getState();
  
  const incorrectSoundsPlayed =
    NUMBER_OF_INCORRECT_SOUNDS === audio.incorrectSoundsPlayed
      ? 1
      : audio.incorrectSoundsPlayed + 1;

  const audioPath = getStringAudioPath(
    editingActivity, 
    solutionLocale, 
    strings, 
    locales, 
    incorrectSoundStrings[incorrectSoundsPlayed - 1]
    );

  const src = audioPath ? audioPath : `${audioURL}/Generic/Feedback/${
    solutionLocale ? solutionLocale.name : 'English'
  }/incorrect${incorrectSoundsPlayed}.mp3`;

  playAudio(src);

  dispatch(setIncorrectSoundsPlayedCount(incorrectSoundsPlayed));
};

export const playWatch = () => (dispatch, getState) => {
  const {
    flinkPlay: { solutionLocale },
    common: { strings, locales },
    flinkMake: { activity: { editingActivity } }
  } = getState();

  const audioPath = getStringAudioPath(
    editingActivity, 
    solutionLocale, 
    strings, 
    locales, 
    1405
    );

  const src = audioPath ? audioPath : `${audioURL}/Generic/Feedback/${
    solutionLocale ? solutionLocale.name : 'English'
  }/watch.mp3`;

  playAudio(src);
};
